import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authEn from '../locales/en/auth.json';
import sidebarEn from '../locales/en/sidebar.json';
import accountEn from '../locales/en/account.json';
import orgSettingsEn from '../locales/en/orgSettings.json';
import subscriptionEn from '../locales/en/subscription.json';
import usersEn from '../locales/en/users.json';
import commonEn from '../locales/en/common.json';
import projectEn from '../locales/en/project.json';
import componentsEn from '../locales/en/components.json';

const supportedLngs = ['en', 'es', 'de', 'fr', 'hu'] as const;

export const defaultNS = 'auth' as const;
export const resources = {
  en: {
    auth: authEn,
    sidebar: sidebarEn,
    account: accountEn,
    orgSettings: orgSettingsEn,
    subscription: subscriptionEn,
    users: usersEn,
    common: commonEn,
    project: projectEn,
    components: componentsEn,
  },
} as const;

export type SupportedLanguage = (typeof supportedLngs)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use({
    type: 'backend' as const,
    read(language: string, namespace: string, callback: (err: Error | null, data: Record<string, string> | null) => void) {
      const lang = supportedLngs.includes(language as SupportedLanguage) ? language : 'en';
      import(`../locales/${lang}/${namespace}.json`)
        .then((module) => callback(null, module.default))
        .catch((error) => callback(error, null));
    },
  })
  .init({
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    supportedLngs,
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    debug: import.meta.env.DEV,
    defaultNS: 'auth',
    ns: ['auth', 'sidebar', 'account', 'orgSettings', 'subscription', 'users', 'common', 'project', 'components'],
    react: {
      useSuspense: true,
    },
  });

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  fr: 'Français',
  hu: 'Magyar',
};

export { supportedLngs };
export default i18n;
